import { ReactNode, useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import ArrowDownIcon from "@/icons/arrows/arrow-down-v3.svg";
import { cn } from "~/lib/utils";

interface MegaMenuProps {
    text: string;
    children: ReactNode;
}

const MegaMenu = ({ text, children }: MegaMenuProps) => {
    const [isActive, setActive] = useState(true);
    const pathname = usePathname();

    useEffect(() => {
        setActive(false);
        setTimeout(setActive, 500, true);
    }, [pathname]);

    return (
        <div className="group cursor-pointer flex items-center justify-center gap-[7px] px-5">
            <span className="relative font-suisseBP text-[16px] leading-[60px] font-normal capitalize text-trueBlack group-hover:text-primary400 transition-all duration-200 ease-in-out pt-[2px]">
                {text}
                <div className="absolute bottom-[1px] left-0 w-full h-[2px] bg-primary400
                    transition-all duration-200 ease-in-out
                    opacity-0 invisible
                    group-hover:opacity-100 group-hover:visible"></div>
            </span>

            <ArrowDownIcon width={10} height={5} className="dropdown-arrow stroke-trueBlack group-hover:stroke-primary400 group-hover:rotate-180 transition-transform duration-200 ease-in-out" />

            <div className={cn(
                "absolute z-[1] top-[100%] left-0 right-0 pt-2 cursor-auto",
                "invisible opacity-0",
                "scale-[0.98] -translate-y-[10px]",
                "transition-all duration-200 ease-in-out origin-top",
                "group-hover:opacity-100 group-hover:visible",
                "group-hover:scale-100 group-hover:translate-y-0",
                { "pointer-events-none": !isActive }
            )}>
                <div className="bg-pureWhite/90 backdrop-blur-lg px-12 py-[60px] rounded-3xl overflow-hidden">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default MegaMenu;
